import { Bom, BomApi, BomItem, BomItemApi, BomReplaceItemApi } from "@/types/bom";

export const transferBomApiToBom: (bom: BomApi) => Bom = (bom) => {

  const getBomItem: (bomItem: BomItemApi | BomReplaceItemApi, pLevel: number) => BomItem = (bomItem, pLevel) => {
    const bomItemInfo: BomItem = {
      ...bomItem,
      level: 'level' in bomItem ? bomItem.level : pLevel,
      type: 'level' in bomItem ? 'formal' : 'req',
      reps: [],
      subs: 'subs' in bomItem ? [
        ...bomItem.reps.map((item) => getBomItem(item, pLevel + 1)),
        ...bomItem.subs.sort((a, b) => a.index - b.index).map((item) => getBomItem(item, pLevel + 1)),
      ] : [],
      pid: 'pid' in bomItem ? bomItem.pid : '',
      extraRate: bomItem.extraRate ?? 0,
      process: bomItem?.process ?? ''
    }

    return bomItemInfo
  }

  const bomInfo: Bom = {
    ...bom,
    id: bom.id,
    bomId: bom.bomId,
    bomState: bom.bomState,
    productId: bom.productId,
    type: bom.type,
    status: bom.status,
    approvaler: bom.approvaler,
    bomDate: bom.bomDate,
    bomCreateDate: bom.bomCreateDate,
    bomCreateDateBy: bom.bomCreateDateBy,
    bomUpdateDate: bom.bomUpdateDate,
    bomUpdateDateBy: bom.bomUpdateDateBy,
    product: bom.product,
    items: bom?.items ? bom?.items?.map((item) => getBomItem(item, 0)) : [],
    version: bom.version,
    versionDesc: bom.versionDesc,
  }

  return bomInfo;
};
